/**
 * P-19a item 4 — D-146: finishing a timer's log on a SERVICE REQUEST. The
 * window offers the ticket's status, "מה בוצע" and "שליחת עדכון ללקוח"
 * (a message + files / voice / screen recording, optionally "מחכה לתשובה").
 * Pure: what is sent, in which order. Unit-tested in
 * src/utils/__tests__/ticketStopModel.test.ts.
 */

/** The statuses offered after work (נסגרה is the customer's / the 7-day job's). */
export const TICKET_STOP_STATUSES = ['new', 'in_progress', 'waiting_customer', 'completed'] as const;
/** At most this many files on one update (as the portal, Q-99). */
export const MAX_UPDATE_FILES = 5;

export interface TicketStopInput {
  before: string | null;
  chosen: string;
  updateText: string;
  fileCount: number;
  awaitReply: boolean;
}

export interface TicketStopPlan {
  /** Post the update as a customer reply (never an internal note). */
  sendUpdate: boolean;
  content: string;
  /** The server moves the ticket to "ממתינה ללקוח" (await_reply). */
  awaitReply: boolean;
  /** A plain status change to send after the update (null = none). */
  setStatus: string | null;
  /** "סיום עבודה" → completed runs through the close flow (its checks and undo). */
  close: boolean;
}

export function ticketStopPlan(i: TicketStopInput): TicketStopPlan {
  const text = i.updateText.trim();
  const sendUpdate = text.length > 0 || i.fileCount > 0;
  const awaitReply = sendUpdate && i.awaitReply;
  const done = (s: string | null) => s === 'completed' || s === 'closed';
  const close = i.chosen === 'completed' && !done(i.before);
  // "מחכה לתשובה" already sets ממתינה ללקוח; completed goes through the close flow.
  let setStatus: string | null = null;
  if (!close && i.chosen !== i.before && !(awaitReply && i.chosen === 'waiting_customer')) setStatus = i.chosen;
  if (awaitReply && setStatus && setStatus !== 'waiting_customer') setStatus = null; // the reply's wait wins
  return { sendUpdate, content: text || '📎', awaitReply, setStatus, close };
}
